__turbopack_context__.v({
  "count": "CapacityConflictItemGroupHeader-module-scss-module__ioVnxG__count",
  "header": "CapacityConflictItemGroupHeader-module-scss-module__ioVnxG__header",
  "label": "CapacityConflictItemGroupHeader-module-scss-module__ioVnxG__label",
  "remove": "CapacityConflictItemGroupHeader-module-scss-module__ioVnxG__remove",
});
